import { render, staticRenderFns } from "./BulkAssignPlansModal.vue?vue&type=template&id=233c3136&scoped=true&"
import script from "./BulkAssignPlansModal.vue?vue&type=script&lang=ts&"
export * from "./BulkAssignPlansModal.vue?vue&type=script&lang=ts&"
import style0 from "./BulkAssignPlansModal.vue?vue&type=style&index=0&id=233c3136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233c3136",
  null
  
)

export default component.exports